module.exports = __webpack_public_path__ + "static/img/8.c927ce77.jpg";